import script from "./footerView.vue?vue&type=script&setup=true&lang=js"
export * from "./footerView.vue?vue&type=script&setup=true&lang=js"

import "./footerView.vue?vue&type=style&index=0&id=5c9abc4a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c9abc4a"]])

export default __exports__